import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C1489.35529,0 1920,430.644706 1920,960 C1920,1489.35529 1489.35529,1920 960,1920 C430.644706,1920 0,1489.35529 0,960 C0,430.644706 430.644706,0 960,0 Z M960,112.941176 C492.875294,112.941176 112.941176,492.875294 112.941176,960 C112.941176,1427.12471 492.875294,1807.05882 960,1807.05882 C1427.12471,1807.05882 1807.05882,1427.12471 1807.05882,960 C1807.05882,492.875294 1427.12471,112.941176 960,112.941176 Z M800.156615,711 C913.347852,711 970,762.572028 970,865.418372 C970,883.075531 967.274014,900.169766 961.823088,916.322648 C956.372163,932.475531 946.916006,948.677683 933.511147,964.886124 C920.106288,981.037959 899.998476,994.365738 873.160493,1004.64199 C846.379039,1014.86268 814.590523,1020.24138 777.851474,1020.24138 L777.851474,1020.24138 L687.199871,1020.24138 L687.199871,1167 L571,1167 L571,711 Z M686,797 L686,935 L785.10066,935 C809.039419,935 826.999797,928.490477 839.011234,915.266663 C851.021619,902.042848 857,885.922879 857,866.283 C857,820.16924 832.056082,797.437889 782.139857,797.437889 L782.139857,797.437889 L686.386923,797.437889 L686,797 Z M1182.20509,711 C1255.76881,711 1313.50609,729.769379 1355.35924,766.975834 C1397.10122,804.18229 1418,861.641434 1418,938.977986 C1418,1016.39945 1397.10122,1073.88585 1355.35924,1111.03674 C1313.50609,1148.2432 1255.79713,1167 1182.20509,1167 L1182.20509,1167 L1003.03356,1167 L1003,1166.72116 L1003,711 Z M1118,806 L1118.18524,806.027378 L1118.18524,1072 L1184.82012,1072 C1225.55121,1072 1255.07811,1059.80843 1273.45524,1035.63801 C1291.80516,1011.52339 1301,979.271233 1301,938.932082 C1301,898.592931 1291.84492,866.313396 1273.495,842.170348 C1255.14509,818.112591 1225.15667,806.083187 1183.4523,806.083187 L1183.4523,806.083187 L1118,806 Z",
  fillRule: "evenodd",
  stroke: "#979797",
  strokeWidth: "1"
});

var IconFilesPublicDomainLine = /*#__PURE__*/function (_Component) {
  _inherits(IconFilesPublicDomainLine, _Component);

  var _super = _createSuper(IconFilesPublicDomainLine);

  function IconFilesPublicDomainLine() {
    _classCallCheck(this, IconFilesPublicDomainLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconFilesPublicDomainLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFilesPublicDomain",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFilesPublicDomainLine.displayName = "IconFilesPublicDomainLine";
  return IconFilesPublicDomainLine;
}(Component);

IconFilesPublicDomainLine.glyphName = 'files-public-domain';
IconFilesPublicDomainLine.variant = 'Line';
IconFilesPublicDomainLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFilesPublicDomainLine;
export { IconFilesPublicDomainLine };